define('fukit/view/block/type.ahead.finder.view',['require','exports','module','underscore','uikit/uikit','../../behavior/type.ahead.search.behavior'],function(require, exports, module) {
  //prettier-ignore
  var _                       = require('underscore'),
      UIKit                   = require('uikit/uikit'),
      TypeAheadSearchBehavior = require('../../behavior/type.ahead.search.behavior');

  var TypeAheadFinderView = UIKit.Input.extend({
    options: _.extend({}, UIKit.Input.prototype.options, {
      placeholder: 'Search to add a person...',
      icon: 'search',
      typeAheadFind: true,
    }),
    queryFields: [],
    additionalSearchServiceParams: {},
    onResultSelected: null,
    allowFreeText: false,
    autocompleteCollection: null,
    autocompleteDropdownBindings: {
      text: 'name',
    },
    wildcardPrefix: '*',
    wildcardSuffix: '*',
    excludeInactives: false,
    useStaticCollection: false,
    searchResultsView: UIKit.SearchResults,
    additionalBehaviors: {},

    behaviors: function() {
      var additionalBehaviors = this.getOption('additionalBehaviors');

      return _.extend({}, additionalBehaviors, {
        SearchBehavior: {
          behaviorClass: TypeAheadSearchBehavior,
          queryFields: this.getOption('queryFields'),
          additionalSearchServiceParams: this.getOption('additionalSearchServiceParams'),
          onResultSelected: this.getOption('onResultSelected'),
          allowFreeText: this.getOption('allowFreeText'),
          autocompleteCollection: this.getOption('autocompleteCollection'),
          autocompleteDropdownBindings: this.getOption('autocompleteDropdownBindings'),
          wildcardPrefix: this.getOption('wildcardPrefix'),
          wildcardSuffix: this.getOption('wildcardSuffix'),
          excludeInactives: this.getOption('excludeInactives'),
          useStaticCollection: this.getOption('useStaticCollection'),
          searchResultsView: this.getOption('searchResultsView'),
        },
      });
    },
  });
  module.exports = TypeAheadFinderView;
});

